module.exports = __webpack_public_path__ + "static/assets/cf943c415522511875f16e7e7b760614.png";